import React from "react"
import PropTypes from "prop-types"
import { Flex } from "antd"
import { CustomSelect } from "ui/Input/Select"
import EquipmentFilters from "../EquipmentFilters"
import { CALENDAR_TABS } from "../../constants"
import styles from "../../Calendar.module.css"

/** The Crew and Equipment tabs' own filters. Every other tab uses `DesktopFilterPills`. */
const DesktopFiltersRow = ({
  activeTab,
  filters,
  crewFilters,
  setFilters,
  setCrewFilters,
  crewMemberOptionsWithUnassigned,
  roles,
  calendarFilterSelectProps,
  setEquipmentCategoryOptions,
  crewLoaded
}) => {

  const renderFilters = () => {
    if (activeTab === CALENDAR_TABS.CREW) {
      return (
        <>
          <div className={styles.filterSelectWrapper}>
            <CustomSelect
              mode="multiple"
              placeholder="Roles"
              style={{ width: "100%" }}
              className={styles.calendarFilterSelect}
              {...calendarFilterSelectProps}
              value={crewLoaded ? crewFilters.roles : []}
              onChange={(v) => setCrewFilters((prev) => ({ ...prev, roles: v }))}
              options={Array.isArray(roles) ? roles.map((r) => ({ label: r.name, value: r.id })) : []}
              maxTagCount={0}
              allowClear
              showSearch={false}
              tagRender={() => null}
            />
            {crewLoaded && crewFilters.roles.length > 0 && (
              <div className={styles.filterCountOverlay}>{`Roles (${crewFilters.roles.length})`}</div>
            )}
          </div>
          <div className={styles.filterSelectWrapper}>
            <CustomSelect
              mode="multiple"
              placeholder="Crew Member"
              style={{ width: "100%" }}
              className={styles.calendarFilterSelect}
              {...calendarFilterSelectProps}
              value={crewLoaded ? crewFilters.crewMembers : []}
              onChange={(v) => setCrewFilters((prev) => ({ ...prev, crewMembers: v }))}
              options={crewMemberOptionsWithUnassigned}
              maxTagCount={0}
              allowClear
              showSearch={false}
              tagRender={() => null}
            />
            {crewLoaded && crewFilters.crewMembers.length > 0 && (
              <div className={styles.filterCountOverlay}>{`Crew Member (${crewFilters.crewMembers.length})`}</div>
            )}
          </div>
        </>
      )
    }
    if (activeTab === CALENDAR_TABS.EQUIPMENT) {
      return (
        <EquipmentFilters
          value={filters.equipmentFilters || {}}
          onChange={(val) => setFilters((prev) => ({ ...prev, equipmentFilters: val }))}
          onOptionsChange={({ categoryOptions }) => setEquipmentCategoryOptions(categoryOptions || [])}
          hideSearch
          selectProps={calendarFilterSelectProps}
        />
      )
    }
    // All Bookings and My Bookings use the Experience / Resources pills instead.
    return null
  }

  return (
    <Flex align="center" gap={12} className={styles.calendarFilters} wrap>
      {renderFilters()}
    </Flex>
  )
}

DesktopFiltersRow.propTypes = {
  activeTab: PropTypes.string.isRequired,
  filters: PropTypes.object.isRequired,
  crewFilters: PropTypes.object.isRequired,
  setFilters: PropTypes.func.isRequired,
  setCrewFilters: PropTypes.func.isRequired,
  crewMemberOptionsWithUnassigned: PropTypes.array.isRequired,
  roles: PropTypes.array,
  calendarFilterSelectProps: PropTypes.object,
  setEquipmentCategoryOptions: PropTypes.func.isRequired,
  crewLoaded: PropTypes.bool
}

export default DesktopFiltersRow
